"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Snackbar = void 0;
var Snackbar_1 = __importDefault(require("./Snackbar"));
exports.Snackbar = Snackbar_1.default;
exports.default = Snackbar_1.default;
//# sourceMappingURL=index.js.map